import React, { ChangeEvent, useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

import ContactHelper from '../../core/libs/ContactHelper';
import { CeilingLabel, CeilingLabelContainer } from '../styled';
import { DropDownClickable, FieldCol } from '../styled/ContactsForm';

import { TAppDate, } from 'TProtocol/common/models';

interface Props {
  birthday: TAppDate | undefined;
  handleBirthdayChange: (value: string, fieldAttribute: 'month' | 'day' | 'year') => void;
  label: string;
}

const currentYear = ContactHelper.localDate().getFullYear();
const numDays = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export default function BirthdayField(props: Props) {
  const [month, setMonth] = useState('');
  const [day, setDay] = useState('');
  const [year, setYear] = useState('');

  useEffect(() => {
    if (props.birthday) {
      if (props.birthday.month) {
        setMonth(props.birthday.month);
      }
      if (props.birthday.day) {
        setDay(props.birthday.day);
      }
      if (props.birthday.year) {
        setYear(props.birthday.year);
      }
    }
  }, [props.birthday]);

  const handleBirthdayChange = (e: ChangeEvent<HTMLSelectElement>, fieldAttribute: string) => {
    e.preventDefault();

    const value = e.target.value;
    if (fieldAttribute === 'month') {
      e.target.classList.add('selected');
      setMonth(value);
      if (value.length <= 0) {
        setDay('');
      }
      props.handleBirthdayChange(value, 'month');
    } else if (fieldAttribute === 'day') {
      const newDay = month.length <= 0 ? '' : value;
      setDay(newDay);
      props.handleBirthdayChange(value, 'day');
    } else if (fieldAttribute === 'year') {
      setYear(value);
      props.handleBirthdayChange(value, 'year');
    }
  };

  return (
    <Form.Group as={Row} className="gx-2">
      <CeilingLabelContainer as={FieldCol}>
        <CeilingLabel>{props.label}</CeilingLabel>
        <DropDownClickable
          className={month.length > 0 ? '' : ' text-secondary'}
          value={parseInt(month).toString()}
          onChange={(e: ChangeEvent<HTMLSelectElement>) => handleBirthdayChange(e, 'month')}
        >
          <option value="">Month</option>
          <option value="1">January</option>
          <option value="2">February</option>
          <option value="3">March</option>
          <option value="4">April</option>
          <option value="5">May</option>
          <option value="6">June</option>
          <option value="7">July</option>
          <option value="8">August</option>
          <option value="9">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </DropDownClickable>
      </CeilingLabelContainer>

      <FieldCol>
        <DropDownClickable
          className={day.length <= 0 ? ' text-secondary' : ''}
          value={parseInt(day).toString()}
          onChange={(e: ChangeEvent<HTMLSelectElement>) => handleBirthdayChange(e, 'day')}
        >
          <option value="">Day</option>
          {parseInt(month) > 0 ?
            (Array.from(Array(numDays[parseInt(month) - 1]).keys()).map(number => (
              <option key={'days' + number} value={number + 1}>
                {number + 1}
              </option>
            ))) :
            ''
          }
        </DropDownClickable>
      </FieldCol>

      <FieldCol>
        <DropDownClickable
          className={year.length > 0 ? '' : ' text-secondary'}
          value={parseInt(year).toString()}
          onChange={(e: ChangeEvent<HTMLSelectElement>) => handleBirthdayChange(e, 'year')}
        >
          <option value="">Year</option>
          {Array.from(Array(120).keys()).map(number => (
            <option key={'years' + number} value={currentYear - number}>
              {currentYear - number}
            </option>
          ))}
        </DropDownClickable>
      </FieldCol>
    </Form.Group>
  );

}

